import { Component, mixins } from 'nuxt-property-decorator'
import { Context, NuxtAppOptions } from '@nuxt/types'
import { ComponentMixins, CodeKey, Logger, LoggerInterface } from '@/mixins'

export interface InjectedValues {
  $logger: LoggerInterface
}

export interface NuxtAppContext extends Context {
  app: NuxtAppOptions & InjectedValues
}

@Component
export class BaseVue extends mixins<ComponentMixins>(CodeKey, Logger)
  implements InjectedValues {}
